export const H1_TAG = "h1"
export const H2_TAG = "h2"
export const H3_TAG = "h3"
export const H4_TAG = "h4"
